import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';
import {TabNames} from '../core/enums';


@Injectable({
  providedIn: 'root'
})
export class MenuTabService {
  tabNames = TabNames;
  currentTab: BehaviorSubject<string> = new BehaviorSubject(this.tabNames.Speech);

  constructor() { }

  changeTab(tabName: string) {
    this.currentTab.next(tabName);
  }
}
